const $title = $('.dnk-vertical-carousel__ribbon__title')
const $item = $('.dnk-vertical-carousel__ribbon__item')
const $slide = $('.dnk-vertical-carousel__slide')

function getImage(id, _this) {
  const _thisUnit = _this.closest('section')
  const url = `/ajax/vertical-carousel?id=${id}`
  const image = $.ajax(url)
    .done(function (data) {
      _thisUnit.find('.dnk-vertical-carousel__slide').empty()
      _thisUnit.find('.dnk-vertical-carousel__slide').html(data).find('img').css({'opacity' : 0}).animate({'opacity' : 1}, 600);
    })
}


$item.on('click', function(){
  $item.removeClass('active')
  $(this).addClass('active')
  const id = $(this).data('id')
  getImage(id, $(this))
});
